export const mcqKeyMappings: Record<string, number> = {
  Digit1: 0,
  Numpad1: 0,
  Digit2: 1,
  Numpad2: 1,
  Digit3: 2,
  Numpad3: 2,
  Digit4: 3,
  Numpad4: 3,
  Digit5: 4,
  Numpad5: 4,
  Digit6: 5,
  Numpad6: 5,
};

// Temporary compatibility export while legacy imports are migrated.
export const pickGameKeyMappings = mcqKeyMappings;
